import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { api, errMsg } from "../lib/api";
import { PageHeader, Pager } from "../components/common";
import { LeadTable } from "./Leads";
import { MyTasks } from "../components/MyTasks";

const TABS = [["today", "Due today"], ["overdue", "Missed / overdue"], ["upcoming", "Upcoming"], ["none", "Open, no next action"]];

export default function Followups() {
  const [sp, setSp] = useSearchParams();
  const tab = sp.get("tab") || "today";
  const [page, setPage] = useState(1);
  const [d, setD] = useState({ items: [], total: 0, page: 1, page_size: 50 });
  const [counts, setCounts] = useState({});
  const [tick, setTick] = useState(0);
  const refresh = () => setTick((t) => t + 1);
  useEffect(() => {
    api.get("/leads", { params: { due: tab, page, sort: "next_contact_date", order: tab === "overdue" ? -1 : 1 } }).then((r) => setD(r.data)).catch((e) => toast.error(errMsg(e)));
  }, [tab, page, tick]);
  useEffect(() => {
    Promise.all(TABS.map(([k]) => api.get("/leads", { params: { due: k, page_size: 1 } }).then((r) => [k, r.data.total]))).then((x) => setCounts(Object.fromEntries(x))).catch(() => {});
  }, [tick]);
  return (
    <div>
      <PageHeader eyebrow="Accountability" title="Follow-ups" desc="Your daily chase list. Every open lead should have an owner and a next contact date. Missed dates show here until they're logged." />
      <MyTasks />
      <div className="flex flex-wrap gap-2 mb-4">
        {TABS.map(([k, l]) => (
          <button key={k} data-testid={`followup-tab-${k}`} onClick={() => { setPage(1); setSp({ tab: k }); }} className={`border px-3 h-9 text-sm ${tab === k ? "border-primary text-primary" : ""}`}>
            {l} <span className="num text-xs text-muted-foreground ml-1">{counts[k] ?? ""}</span>
          </button>
        ))}
      </div>
      <LeadTable items={d.items} selected={[]} setSelected={() => {}} selectable={false} onChanged={refresh} />
      <Pager page={d.page} total={d.total} size={d.page_size} onPage={setPage} />
    </div>
  );
}
